import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { languageChoiceOf } from '../../../../i18n/languages';
import type { LanguageChoice } from '../../../../i18n/languages';
import type { MySettings } from '../../types/domain.types';
import { mySettingsQueryOptions } from '../../utils/queryOptions';

const effectiveLanguageOf = (settings: MySettings): LanguageChoice | null => settings.language?.effective ?? null;

export const AppLanguageFollower: React.FC = () => {
  const { i18n } = useTranslation();
  const { data: language } = useQuery({ ...mySettingsQueryOptions(), select: effectiveLanguageOf });

  useEffect(() => {
    if (language === undefined || language === null || languageChoiceOf(i18n.language) === language) return;
    void i18n.changeLanguage(language);
  }, [i18n, language]);

  return null;
};
